import React from 'react';
import createSvgIcon from "@/lib/vendor/@material-ui/icons/src/utils/createSvgIcon";

export default createSvgIcon(
  <path d="M7 10l5 5 5-5z" />,
  "ArrowDropDown"
);
